import { createSlice } from '@reduxjs/toolkit';
import { INSPECTOR_DEFAULT } from '../../../../utilities/constants/inspectorConstants';

const initialState = {
  status: 'idle',
  scene: INSPECTOR_DEFAULT,
  pendingAttributeFocus: null,
};

// Slice / Reducer
const inspectorSlice = createSlice({
  name: 'inspector',
  initialState,
  reducers: {
    setScene(state, action) {
      const scene = action.payload.scene;
      state.scene = scene;
    },
    requestAttributeFocus(state, action) {
      state.pendingAttributeFocus = action.payload || null;
    },
    clearAttributeFocus(state) {
      state.pendingAttributeFocus = null;
    },
  },
});

export const { setScene, requestAttributeFocus, clearAttributeFocus } = inspectorSlice.actions;

export default inspectorSlice.reducer;
